export default __webpack_public_path__ + "static/2a)AhhhYeasss-b8979e352c7d2a4ffef725a649085e60.mp3";